import React from "react";
import { MessageCircle, Send, CheckCircle2, Zap } from "lucide-react";
import { hero, contact } from "../../mock";
import WhatsAppImage from "../WhatsAppImage";

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden grid-bg">
      <div className="glow-blob w-[420px] h-[420px] bg-[#00ff87] -top-20 -left-24" />
      <div className="glow-blob w-[360px] h-[360px] bg-[#00e5ff] top-10 right-0" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#00ff87]/10 border border-[#00ff87]/30 text-[#00ff87] text-xs font-semibold mb-6">
              <Zap size={14} /> {hero.badge}
            </span>

            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-extrabold leading-[1.08] text-white">
              {hero.title}{" "}
              <span className="neon-green text-glow-green">{hero.titleHighlight}</span>
            </h1>

            <p className="mt-6 text-gray-300 text-base sm:text-lg leading-relaxed max-w-xl">
              {hero.subtitle}
            </p>

            <ul className="mt-6 space-y-3">
              {hero.points.map((p) => (
                <li key={p} className="flex items-center gap-3 text-gray-200">
                  <CheckCircle2 size={20} className="text-[#00ff87] shrink-0" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href={contact.whatsapp}
                target="_blank"
                rel="noreferrer"
                className="btn-neon inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl font-display font-semibold text-base"
              >
                <MessageCircle size={20} /> Get Cricket ID Now
              </a>
              <a
                href={contact.telegram}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl font-display font-semibold text-base border border-[#00e5ff]/40 text-[#00e5ff] hover:bg-[#00e5ff]/10 transition-colors"
              >
                <Send size={20} /> Join Telegram
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#00ff87]/20 to-[#00e5ff]/20 blur-3xl rounded-full" />
            <div className="neon-ring absolute -inset-4 z-0 hidden md:block" />
            <WhatsAppImage
              src={hero.image}
              alt="DaddyAnna - We accept Google Pay, Paytm, PhonePe, UPI. Fast, safe & secure online cricket id"
              rounded="rounded-2xl"
              className="relative z-10 shadow-2xl animate-floaty"
              plain
              label="Get Cricket ID on WhatsApp"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
